import React, { Suspense, useEffect } from "react";
import PropTypes from "prop-types";
import { Switch, BrowserRouter as Router, useLocation } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./routes";
import Authmiddleware, { ContentRoute } from "./routes/route";
import NonAuthLayout from "./components/NonAuthLayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import ReactGA from "react-ga";
import "./assets/scss/theme.scss";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security, LoginCallback } from "@okta/okta-react";
import oktaConfig from "./oktaConfig";
import CustomErrorComponent from "./components/CustomErrorComponent";
const usePageViews = () => {
  let location = useLocation();
  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);
};

const oktaAuth = new OktaAuth(oktaConfig.oidc);

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  const relativeUrl = toRelativeUrl(originalUri || "/", window.location.origin);
  if (relativeUrl === "/login") {
    window.location.replace("/");
  } else {
    window.location.replace(relativeUrl);
  }
};
const customAuthHandler = () => {
  window.location.replace("/login");
};

const App = () => {
  usePageViews();

  return (
    <React.Fragment>
      <ToastContainer theme="dark" />
      <Router>
        <Security
          oktaAuth={oktaAuth}
          onAuthRequired={customAuthHandler}
          restoreOriginalUri={restoreOriginalUri}
        >
          <ContentRoute>
            <Switch>
              {publicRoutes.map((route, idx) => (
                <Authmiddleware
                  path={route.path}
                  layout={NonAuthLayout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={false}
                  exact
                />
              ))}
              <Authmiddleware
                path="/login/callback"
                layout={NonAuthLayout}
                component={(props) => (
                  <LoginCallback
                    {...props}
                    errorComponent={CustomErrorComponent}
                    loadingElement={<div>Cargando...</div>}
                  />
                )}
                isAuthProtected={false}
                exact
              />
              <Suspense fallback={<h4>Cargando...</h4>}>
                {authProtectedRoutes.map((route, idx) => (
                  <Authmiddleware
                    path={route.path}
                    layout={NonAuthLayout}
                    component={route.component}
                    key={idx}
                    isAuthProtected={true}
                    exact={route.exact}
                  />
                ))}
              </Suspense>
            </Switch>
          </ContentRoute>
        </Security>
      </Router>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;
